<template>
  <div class="home">
    <!-- 左侧品牌区 -->
    <div class="side-panel">
      <div class="brand-content">
        <div class="brand-logo">
          <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- 主图形：六边形 + 十字 -->
            <path d="M40 8 L64 24 L64 56 L40 72 L16 56 L16 24 Z" fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
            <!-- 内圆 -->
            <circle cx="40" cy="40" r="16" fill="rgba(255,255,255,0.2)" stroke="rgba(255,255,255,0.8)" stroke-width="1.5"/>
            <!-- 十字竖线 -->
            <rect x="37.5" y="28" width="5" height="24" rx="2.5" fill="white"/>
            <!-- 十字横线 -->
            <rect x="28" y="37.5" width="24" height="5" rx="2.5" fill="white"/>
          </svg>
        </div>
        <h1 class="brand-name">利杰鑫</h1>
        <p class="brand-desc">专业的医疗健康管理平台</p>
        <div class="brand-tags">
          <span class="tag">智能管理</span>
          <span class="tag">数据安全</span>
          <span class="tag">高效便捷</span>
        </div>
      </div>
      <div class="wave-bottom">
        <svg viewBox="0 0 200 80" preserveAspectRatio="none">
          <path d="M0,40 C30,10 70,70 100,40 C130,10 170,70 200,40 L200,80 L0,80 Z" fill="rgba(255,255,255,0.06)"/>
          <path d="M0,55 C40,25 80,75 120,45 C150,25 180,65 200,55 L200,80 L0,80 Z" fill="rgba(255,255,255,0.04)"/>
        </svg>
      </div>
    </div>

    <!-- 右侧登录区 -->
    <div class="form-panel">
      <div class="form-card">
        <div class="form-header">
          <h2 class="form-title">欢迎回来</h2>
          <p class="form-sub">请登录您的管理账号</p>
        </div>

        <div class="form-body">
          <div class="input-group">
            <label class="input-label">用户名</label>
            <div class="input-wrap" :class="{ focused: focusField === 'user' }">
              <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
              </svg>
              <Field
                placeholder="请输入用户名"
                class="field"
                maxlength="20"
                type="text"
                v-model="loginInfo.userName"
                @focus="focusField = 'user'"
                @blur="focusField = ''"
              />
            </div>
          </div>

          <div class="input-group">
            <label class="input-label">密码</label>
            <div class="input-wrap" :class="{ focused: focusField === 'pass' }">
              <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <Field
                placeholder="请输入密码"
                class="field"
                maxlength="20"
                type="password"
                v-model="loginInfo.password"
                @focus="focusField = 'pass'"
                @blur="focusField = ''"
              />
            </div>
          </div>

          <Button
            type="primary"
            size="large"
            class="confirm"
            :loading="loading"
            loading-text="登录中..."
            @click="loginConfrim"
          >
            {{ loading ? '' : '登录' }}
          </Button>
        </div>

        <p class="form-footer">© 2024 利杰鑫医疗管理系统</p>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, getCurrentInstance, onMounted, ref } from 'vue';
  import { Button, Field, showToast } from 'vant'
  import { adminLogin, getSecondAdmin } from '@/api/index'
  import { useRouter } from 'vue-router';
  import { store } from '@/store/index';
  import 'vant/lib/index.css';

  const router = useRouter();
  const secondUrl = ref('')
  const loginInfo = ref({ userName: '', password: '' })
  const loading = ref(false)
  const focusField = ref('')

  const handleClear = (loginType) => {
    if (loginType == 'username') {
      loginInfo.value.userName = ''
    }
  }

  const loginConfrim = async () => {
    let { userName, password } = loginInfo.value
    if (userName == '' || password == '') {
      showToast('用户名或密码不能为空')
      return
    }

    loading.value = true
    let loginRes = await adminLogin({ adminname: userName, adminpassword: password })
    loading.value = false

    if (loginRes.data.length > 0) {
      localStorage.setItem('isLogin', true)
      if (loginRes.data[0].admintype == 1) {
        secondUrl.value = '/AdminManage'
        let secondRes = await getSecondAdmin({ admintype: 2 })
        // 二级管理员信息
        localStorage.setItem('secondRes', JSON.stringify(secondRes.data))
      } else {
        let urlList = loginRes.data[0].adminurl.split(',')
        secondUrl.value = urlList[0]
      }
      // 管理员登录信息
      localStorage.setItem('logInfo', JSON.stringify(loginRes.data[0]))
      localStorage.setItem('urlindex', 0)
      setTimeout(() => {
        router.push(secondUrl.value)
      }, 200)
    } else {
      console.log(loginRes)
      showToast('用户名或密码错误')
    }
  }
</script>

<style scoped>
/* ===== 整体布局：左右分栏 ===== */
.home {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  min-width: 0;
}

/* ===== 左侧品牌区 ===== */
.side-panel {
  width: 45%;
  background: linear-gradient(160deg, #4f46e5 0%, #6366f1 40%, #818cf8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  animation: slideInLeft 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

/* 左侧背景光斑 */
.side-panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 70% 60% at 20% 30%, rgba(255,255,255,0.12) 0%, transparent 55%),
    radial-gradient(ellipse 50% 40% at 85% 75%, rgba(165,180,252,0.15) 0%, transparent 50%);
}

.brand-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 48px;
}

.brand-logo {
  width: 90px;
  height: 90px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 28px;
  backdrop-filter: blur(8px);
}

.brand-logo svg {
  width: 60px;
  height: 60px;
}

.brand-name {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 6px;
  margin-bottom: 12px;
  text-shadow: 0 2px 12px rgba(0,0,0,0.2);
}

.brand-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 2px;
  margin-bottom: 36px;
}

.brand-tags {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.tag {
  padding: 5px 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 1px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(4px);
}

.wave-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
}

.wave-bottom svg {
  width: 100%;
  height: 100%;
}

/* ===== 右侧登录区 ===== */
.form-panel {
  flex: 1;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 32px;
  animation: slideInRight 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
}

.form-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 48px 40px;
  width: 100%;
  max-width: 400px;
}

/* ===== 小屏幕适配：隐藏左侧 ===== */
@media screen and (max-width: 768px) {
  .side-panel {
    display: none;
  }

  .form-panel {
    width: 100%;
    padding: 32px 24px;
    animation-name: slideInUp;
  }
}

/* 超小屏微调 */
@media screen and (max-width: 480px) {
  .form-card {
    padding: 32px 24px;
    border-radius: 16px;
  }

  .form-title {
    font-size: 24px;
  }

  .brand-name {
    font-size: 30px;
  }
}

.form-header {
  margin-bottom: 40px;
}

.form-title {
  font-size: 30px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.form-sub {
  font-size: 14px;
  color: #999;
  letter-spacing: 0.5px;
}

/* ===== 表单 ===== */
.form-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-label {
  font-size: 13px;
  font-weight: 500;
  color: #555;
  letter-spacing: 0.5px;
}

.input-wrap {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  border: 1.5px solid #e4e8ef;
  transition: border-color 0.2s, box-shadow 0.2s;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}

.input-wrap.focused {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.input-icon {
  width: 18px;
  height: 18px;
  margin-left: 16px;
  color: #bbc0c8;
  flex-shrink: 0;
  transition: color 0.2s;
}

.input-wrap.focused .input-icon {
  color: #6366f1;
}

/* Vant Field 重置 */
.field {
  flex: 1 !important;
  background: transparent !important;
  font-size: 15px !important;
  height: 52px !important;
}

:deep(.van-cell) {
  background: transparent;
  padding: 0 14px;
  line-height: 52px;
  min-height: 52px;
}

:deep(.van-cell::after) {
  display: none;
}

:deep(.van-field__control) {
  font-size: 15px;
  color: #222;
  height: 52px;
  line-height: 52px;
}

:deep(.van-field__body) {
  height: 52px;
}

:deep(.van-field__placeholder) {
  color: #c8cdd6;
  font-size: 14px;
}

/* 登录按钮 */
.confirm {
  height: 52px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 6px;
  border: none !important;
  background: linear-gradient(90deg, #4f46e5, #7c3aed) !important;
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.35) !important;
  transition: opacity 0.2s, transform 0.15s !important;
  margin-top: 4px;
}

.confirm:active {
  opacity: 0.85;
  transform: translateY(1px);
}

:deep(.van-button--primary) {
  background: linear-gradient(90deg, #4f46e5, #7c3aed) !important;
  border-color: transparent !important;
}

:deep(.van-button__text) {
  color: #fff !important;
}

.form-footer {
  text-align: center;
  font-size: 12px;
  color: #bbb;
  margin-top: 36px;
  letter-spacing: 0.5px;
}

/* ===== 入场动画 ===== */
@keyframes slideInLeft {
  from { opacity: 0; transform: translateX(-60px); }
  to   { opacity: 1; transform: translateX(0); }
}

@keyframes slideInRight {
  from { opacity: 0; transform: translateX(60px); }
  to   { opacity: 1; transform: translateX(0); }
}

@keyframes slideInUp {
  from { opacity: 0; transform: translateY(40px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
